// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // appVersion: require('../../package.json').version + '-dev',
  appVersion: require('../../package.json').version,
  production: false,
  hmr: false,

  /**
   * ! opnworx development database
   */

  // appId: 'erp-g360-swati',
  // masterKey: '12345678',
  // serverUrl: 'http://15.237.151.60/parse',
  // SOCKET_ENDPOINT: 'http://15.237.151.60',
  // profileUploadAuthenticationKey: 'SyM52ZMDrK4ZR5LCuFzkDjnMRuHDhuUO',
  // nodeApi: 'http://15.237.151.60',
  // baseUrl: 'http://15.237.151.60'

  //  nodeApi: 'http://localhost:3000'

  /**
   * ! opnworx production details
   */

  appId: 'opnworx',
  masterKey: '12345678',
  serverUrl: 'https://opnworx.com/parse',
  SOCKET_ENDPOINT: 'https://opnworx.com',
  profileUploadAuthenticationKey: 'SyM52ZMDrK4ZR5LCuFzkDjnMRuHDhuUO',
  nodeApi: 'https://opnworx.com',
  baseUrl: 'https://opnworx.com',
  marketingSite: 'https://openworx.us/',
  
  /**
   * ! local environment
  */
 
//  SOCKET_ENDPOINT: 'http://localhost:4000',
//  nodeApi: 'http://localhost:4000',
 
  // appId: 'erp-g360-swati',
  // masterKey: '12345678',
  // serverUrl: 'https://opnworx.com/parse',
  // SOCKET_ENDPOINT: 'http://localhost:3000',
  // profileUploadAuthenticationKey: 'SyM52ZMDrK4ZR5LCuFzkDjnMRuHDhuUO',
  // nodeApi: 'http://localhost:3000'
  // baseUrl: 'https://opnworx.com'

};


/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
